import { render, staticRenderFns } from "./PaginationC.vue?vue&type=template&id=06b9791b&scoped=true&"
import script from "./PaginationC.vue?vue&type=script&lang=ts&"
export * from "./PaginationC.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationC.vue?vue&type=style&index=0&id=06b9791b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9791b",
  null
  
)

export default component.exports